import axios from "axios";

export default {
  data() {
    return {
      apiUrl: this.shareFormConfig.api,
      tenantId: this.realm,
      users: [],
      itemLoaded: {},
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    //Get Users
    getUsers: function () {
      axios
        .get(this.apiUrl + "/" + this.tenantId + "/users", this.opts)
        .then((response) => {
          this.users = response.data;
          // show the shared users, remove owner from users list, add the owner by default to the shared users list
          this.users.forEach((x) => {
            if (x._id === this.itemLoaded.owner) {
              this.sharedUsers.push(x);
              this.users.splice(this.users.indexOf(x), 1);
            }
          });
          this.itemLoaded.sharedWith?.forEach((y) => {
            this.users.forEach((x) => {
              if (x._id === y.user) {
                this.sharedUsers.push(x);
                this.users.splice(this.users.indexOf(x), 1);
              }
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getItemToShare() {
      axios
        .get(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/" +
            this.root +
            "/" +
          this.itemToShare._id,
          this.opts,
        )
        .then((response) => {
          this.itemLoaded = response.data;
          this.getUsers();
        });
    },
  },
};
